import { render, staticRenderFns } from "./reportService.vue?vue&type=template&id=0f6b16a8&scoped=true"
import script from "./reportService.vue?vue&type=script&lang=js"
export * from "./reportService.vue?vue&type=script&lang=js"
import style0 from "./reportService.vue?vue&type=style&index=0&id=0f6b16a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b16a8",
  null
  
)

export default component.exports